// delivery price by postcode on /betalnings-och-leveransvillkor
$(function() {
    //postcode module html template
    $('#PostCodeModule').html(
        '<div ><strong>Leveranskostnad: </strong>' +
        '<strong id="calculatedDeliveryPrice">Ange postnummer för leveranskostnad</strong></div>' +
        '<input id="PostcodeToCalculateDeliveryPrice" type="number" placeholder = "Ange postnummer">' +
        '<button id="PostcodeToCalculateDeliveryPriceButton" class="blue-btn calculate-delivery-btn">Räkna ut leveranskostnad</button>');

    var postcodeInput = $('#PostcodeToCalculateDeliveryPrice');
    var postcodeInputValue = null;

    $('#PostcodeToCalculateDeliveryPriceButton').on('click', function() {
        postcodeInputValue = postcodeInput.val();
        postcodeMuduleEventHandler();
    });

    $('#PostcodeToCalculateDeliveryPrice').on('keypress', function(event) {
        postcodeInputValue = postcodeInput.val();
        if (event.keyCode === 13) {
            postcodeMuduleEventHandler();
        }
    });

    function postcodeMuduleEventHandler() {
        if (postcodeInputValue.length === 5) {
            $('#PostcodeToCalculateDeliveryPrice').attr('disabled', 'disabled');
            homedeliveryCheckPrice(
                postcodeInputValue,
                function(response) {
                    $('#calculatedDeliveryPrice').text(response.data.delivery_price + ' :-*').addClass('red');
                    $('#PostcodeToCalculateDeliveryPrice').removeAttr('disabled');
                },
                0,
                2
            );

        } else if (postcodeInputValue.length > 0 && postcodeInputValue.length != 5) {
            $('#calculatedDeliveryPrice').text('Felaktigt postnummer').removeClass('red');
        } else {
            $('#calculatedDeliveryPrice').text('Ange postnummer för leveranskostnad').removeClass('red');
        }
    }
});

$(function () {
    $('.gallery-item').magnificPopup({
        type: 'image',
        gallery: {
            enabled: true
        },
        image: {
            titleSrc: function (item) {
                var caption = item.el.attr('title');
                return caption;
            }
        }
    });
    $('.gallery-wrapper').magnificPopup({
        delegate: 'img',
        type: 'image',
        gallery: {
            enabled: true
        },
        callbacks: {
            elementParse: function(item) {
                item.src = item.el.attr('src');
            }
        }
    });
    $('.custom-page-side-menu__show').click(function () {
        $(this).parent().addClass('--active');
    });
    $('.custom-page-side-menu__hide').click(function () {
        $(this).parent().removeClass('--active');
    });
});
